// import Navbar from './components/Navbar/navbar';


function App({customComponent: CustomCompoent}) {
  return (
    <div className="App">
      {CustomCompoent && <CustomCompoent/>}
    </div>
  );
}

export default App;